/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 28.06.24
 *
 */
import BaseObject from "@shared/BaseObject.js";

export default class PriceItem extends BaseObject {

	planId: string[] = []
	price: number = null
	currencyCode: string = null


	constructor(planId = [], price, currencyCode = "USD") {
		super();
		if(!Array.isArray(planId)){
			planId = [planId]
		}
		this.planId = planId;
		this.price = price;
		this.currencyCode = currencyCode;
	}
}
